import { assertInInjectionContext, inject, Injector, runInInjectionContext } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, Observable, of, pipe, switchMap, tap, UnaryFunction } from 'rxjs';
import { LoggerWithConfigurationService } from '../../service/internal/logger-with-configuration.service';
import { UserService } from '../../service/user/user.service';
import { createPrefixMessage } from '../prefix-message.function';

export function andUserIs<T>(
  target: string,
  { injector }: { injector?: Injector } = {},
): UnaryFunction<Observable<T>, Observable<T>> {
  if (!injector) {
    assertInInjectionContext(andUserIs);
    injector = inject(Injector);
  }
  return runInInjectionContext(injector, () => {
    const prefixMessage = createPrefixMessage('andUserIs');
    const loggerService = inject(LoggerWithConfigurationService);
    const andUserIs$ = toObservable(inject(UserService).user.is(target));

    return pipe(
      switchMap((value: T) =>
        of(value).pipe(
          tap(() => {
            loggerService.logDebug(prefixMessage(`Checking user roles.`));
          }),
          switchMap(() => andUserIs$),
          filter((result) => result),
          map(() => value),
        ),
      ),
    );
  });
}
